import { useState } from "react"
import type { FaqItem } from "../data/affiliateContent"

interface Props {
  faqData: FaqItem[]
  chipTitle?: string
  mainTitle?: string
  allowHtml?: boolean
}

export function MarketingFaqSection({
  faqData,
  chipTitle = "Features",
  mainTitle = "Frequently asked questions",
  allowHtml = false,
}: Props) {
  const [openId, setOpenId] = useState<string | null>(null)

  return (
    <div className="mk-section mk-section-alt">
      <div className="mk-container">
        <div className="mk-faq-layout">
          {/* Left side: title + discord link */}
          <div className="mk-faq-left">
            <span className="mk-chip">
              <span className="mk-chip-icon">
                <img src="/marketing/go/icons/message.svg" alt="" />
              </span>
              {chipTitle}
            </span>
            <h2 className="mk-title" style={{ textAlign: "left" }}>
              {mainTitle}
            </h2>
            <div style={{ flexGrow: 1 }} />
            <p className="mk-faq-discord">
              Still have questions?
              <br />
              <a
                href="https://discord.gg/mqcPWsQRgS"
                target="_blank"
                rel="noopener noreferrer"
              >
                Join our Discord
              </a>{" "}
              and ask the community!
            </p>
          </div>

          {/* Right side: accordion */}
          <div className="mk-faq-right">
            {faqData.map((item) => {
              const isOpen = openId === item.id
              return (
                <div key={item.id} className="mk-faq-item">
                  <button
                    className="mk-faq-question"
                    onClick={() => setOpenId(isOpen ? null : item.id)}
                    aria-expanded={isOpen}
                  >
                    <span>{item.question}</span>
                    <span className={`mk-faq-chevron ${isOpen ? "open" : ""}`}>
                      <svg focusable="false" aria-hidden="true" viewBox="0 0 24 24">
                        <path d="M16.59 8.59 12 13.17 7.41 8.59 6 10l6 6 6-6z" />
                      </svg>
                    </span>
                  </button>
                  {isOpen && (
                    <div className="mk-faq-answer">
                      {allowHtml ? (
                        <p dangerouslySetInnerHTML={{ __html: item.answer }} />
                      ) : (
                        <p>{item.answer}</p>
                      )}
                    </div>
                  )}
                </div>
              )
            })}
          </div>
        </div>
      </div>
    </div>
  )
}
